import { render } from "./CheckoutFulfillmentChoice.vue?vue&type=template&id=183af8fa&scoped=true"
import script from "./CheckoutFulfillmentChoice.vue?vue&type=script&lang=js"
export * from "./CheckoutFulfillmentChoice.vue?vue&type=script&lang=js"

import "./CheckoutFulfillmentChoice.vue?vue&type=style&index=0&id=183af8fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183af8fa"]])

export default __exports__